<template>
  <tr class="database-row">
    <td></td>
    <td></td>
    <td>
      <v-row>
        <FavoriteStar :id="row.id" :selected="row.favorite" type="quote" @update="(val) => (row.favorite = val)" />
        <span class="ml-2">{{ row.client_name }}</span>
      </v-row>
    </td>
    <td>{{ row.number_of_nights }}</td>
    <td>{{ row.title }}</td>
    <td>{{ row.city_start }}</td>
    <td>{{ row.city_end }}</td>
    <td>{{ this.formatDate(row.start_date) }} - {{ this.formatDate(row.end_date) }}</td>
    <td>{{ row.reference }}</td>
    <td>V {{ row.version }}</td>
  </tr>
</template>

<script>
import FavoriteStar from "@/modules/database/components/tables/subcontent/_FavoriteStar";

export default {
  props: {
    item: Object,
  },
  components: {
    FavoriteStar,
  },
  computed: {
    row: {
      get() {
        return this.item;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "-";

      const { year, month, day } = date;

      if (year) {
        const options = { year: "numeric" };
        if (month) options.month = "long";
        if (day) options.day = "numeric";

        const dateObject = new Date(year, (month || 1) - 1, day || 1);
        return dateObject.toLocaleDateString("en-US", options);
      }

      return "-";
    },
  },
};
</script>
